import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingDialogComponent } from './loading-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [LoadingDialogComponent],
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
  exports: [LoadingDialogComponent],
})
export class LoadingDialogModule {}
